import { Fab } from '@mui/material';
import { Cookie as CookieIcon } from '@mui/icons-material';
import Proptypes from 'prop-types';

function CookiePreferenceButton({ onClick }) {
  return (
    <Fab color="secondary" aria-label="edit" onClick={onClick} sx={{ position: 'fixed', bottom: 16, right: 16 }}>
      <CookieIcon />
    </Fab>
  );
}

CookiePreferenceButton.propTypes = {
  onClick: Proptypes.func.isRequired,
};

export default CookiePreferenceButton;
